import { useState } from 'react';

/**
 * Estado do filtro "Somente técnicos com OS" no Board.
 * @returns {[boolean, function(boolean): void]}
 */
export function useOnlyTechniciansWithOSFilter() {
  const [onlyTechniciansWithOS, setOnlyTechniciansWithOS] = useState(false);
  return [onlyTechniciansWithOS, setOnlyTechniciansWithOS];
}
